module.exports = __webpack_public_path__ + "img/quick-price.fbecf687.png";